var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMySephoraBronzeFid = function SvgMySephoraBronzeFid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C17C55",
    d: "M30.5 16c0 7.732-6.268 14-14 14s-14-6.268-14-14 6.268-14 14-14 14 6.268 14 14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M18.499 18.097c.074 4.075-3.18 6.903-3.18 6.903 1.935-3.946.124-5.995-.644-9.363C13.666 11.207 17.352 7 17.352 7c-2.116 3.789 1.104 8.726 1.147 11.097",
    clipRule: "evenodd"
  })));
};
export default SvgMySephoraBronzeFid;